import React from 'react';
import { LangSelectProfile } from 'config';
import { components, ControlProps } from 'react-select';

export const CustomControl =
  (icon?: JSX.Element) => (props: ControlProps<LangSelectProfile, false>) => {
    const { children, innerProps, ...rest } = props;

    return (
      <components.Control
        {...rest}
        innerProps={
          {
            ...(innerProps as React.HTMLAttributes<HTMLDivElement>),
            'data-testid': 'dropdown-language-control',
          } as React.HTMLAttributes<HTMLDivElement>
        }
      >
        {icon}
        {children}
      </components.Control>
    );
  };
